import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Select } from 'ziphy-web-shared/basic/lib/forms/fields';
import { useDefinitionSelectItems } from 'ziphy-web-shared/basic/lib/forms/fields/select/Select.hooks';
import { getSelectProps } from './';
const SelectDefault = ({ $element }) => {
    const { fieldProps } = useMemo(() => getSelectProps($element), [$element.config]);
    const { config, renderType, field } = $element;
    const selectIdOptions = useDefinitionSelectItems(config.selectId);
    const items = (selectIdOptions === null || selectIdOptions === void 0 ? void 0 : selectIdOptions.length) ? selectIdOptions : config.options || [];
    if (renderType === 'plain') {
        const values = Array.isArray(field.value) ? field.value : Object.keys(field.value || {});
        if (!values || values.length === 0)
            return null;
        const options = items && items.length > 0
            ? 'items' in items[0]
                ? items.reduce((acc, item) => {
                    return [...acc, ...item.items];
                }, [])
                : items
            : null;
        return values && options ? (_jsx("span", { children: values.map((key) => { var _a; return ((_a = options.find((item) => item.id === key)) === null || _a === void 0 ? void 0 : _a.text) || key; }).join(', ') })) : null;
    }
    return _jsx(Select, Object.assign({ field: field, items: items }, fieldProps));
};
export default observer(SelectDefault);
